<template>
  <div class="text-black my-3 fs-14">
    <div
      class="sticky top-0 flex justify-content-end bg-white text-base font-semibold z-50 mb-3 shadow-sm"
    >
      <template v-if="treatmentId || form.id">
        <button
          class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
          @click="openModalSignPDF()"
        >
          <div class="loading">
            <div v-if="loading" class="spinner-border mr-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 16 16"
          >
            <path
              fill="#03267A"
              d="M9.021 1.772a2.445 2.445 0 0 1 3.458 3.457l-.272.271l.086.086a2 2 0 0 1 0 2.828l-1.44 1.44a.5.5 0 0 1-.707-.707l1.44-1.44a1 1 0 0 0 0-1.414l-.086-.086l-5.646 5.647a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.595-.643l1.25-3.75a.5.5 0 0 1 .12-.195l6.625-6.625Zm2.75.707a1.445 1.445 0 0 0-2.042 0L3.187 9.02l-.925 2.774l2.982-.745l6.527-6.527a1.445 1.445 0 0 0 0-2.043ZM4.967 15c-1.235 0-2.208-.566-2.855-1.107l1.284-.32a3.2 3.2 0 0 0 1.57.427c.406 0 .824-.164 1.27-.457c.447-.293.878-.687 1.314-1.095l.113-.107c.385-.361.784-.737 1.166-.996c.408-.278.95-.53 1.517-.311c.376.144.62.41.791.736c.161.306.272.688.38 1.105c.05.19.133.374.23.498a.46.46 0 0 0 .114.112c.025.015.036.015.039.015c.122 0 .331-.082.63-.286c.185-.126.344-.252.502-.379c.098-.078.197-.157.302-.235c.279-.209.52-.349.697-.438a3.05 3.05 0 0 1 .278-.124l.02-.008l.007-.002l.003-.001h.001l.16.473l-.159-.474a.5.5 0 0 1 .321.947l-.004.002a2.141 2.141 0 0 0-.175.08c-.13.064-.321.174-.55.346c-.059.043-.135.104-.223.174c-.181.143-.409.324-.618.466c-.31.212-.741.46-1.192.46c-.436 0-.751-.265-.946-.517a2.435 2.435 0 0 1-.405-.858c-.11-.423-.196-.7-.296-.89c-.09-.168-.17-.232-.266-.27c-.082-.03-.245-.033-.595.206c-.313.212-.655.533-1.058.912l-.1.093c-.431.405-.92.855-1.449 1.202c-.53.348-1.14.621-1.818.621Z"
            />
          </svg>
          {{ $t("multidisciplinary_board.btn_sign") }}
        </button>
        <button
          class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
          @click="showModalSaveDocTemplate(true)"
        >
          <div class="loading">
            <div v-if="loading" class="spinner-border mr-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="copy-icon"
          >
            <path
              d="M16 20H8C7.20435 20 6.44129 19.6839 5.87868 19.1213C5.31607 18.5587 5 17.7956 5 17V7C5 6.73478 4.89464 6.48043 4.70711 6.29289C4.51957 6.10536 4.26522 6 4 6C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 18.3261 3.52678 19.5979 4.46447 20.5355C5.40215 21.4732 6.67392 22 8 22H16C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5196 17 21.2652 17 21C17 20.7348 16.8946 20.4804 16.7071 20.2929C16.5196 20.1054 16.2652 20 16 20ZM10 13C10 13.2652 10.1054 13.5196 10.2929 13.7071C10.4804 13.8946 10.7348 14 11 14H16C16.2652 14 16.5196 13.8946 16.7071 13.7071C16.8946 13.5196 17 13.2652 17 13C17 12.7348 16.8946 12.4804 16.7071 12.2929C16.5196 12.1054 16.2652 12 16 12H11C10.7348 12 10.4804 12.1054 10.2929 12.2929C10.1054 12.4804 10 12.7348 10 13ZM21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11C14.4402 2.10576 14.4099 2.10576 14.38 2.11C14.2784 2.05174 14.1662 2.01434 14.05 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13.0027 7.34114 13.0636 7.67933 13.18 8H11C10.7348 8 10.4804 8.10536 10.2929 8.29289C10.1054 8.48043 10 8.73478 10 9C10 9.26522 10.1054 9.51957 10.2929 9.70711C10.4804 9.89464 10.7348 10 11 10H19V15Z"
              fill="#03267A"
            />
          </svg>
          {{ $t("multidisciplinary_board.btn_save_tem") }}
        </button>
        <button
          class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
          @click="onPrintNe()"
          :disabled="loading"
        >
          <div class="loading" v-if="loading">
            <div class="spinner-border mr-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 14H17C17.2652 14 17.5196 13.8946 17.7071 13.7071C17.8946 13.5196 18 13.2652 18 13V7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6H3C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H4V9H16V14ZM4 4V0H16V4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V13C20 13.7956 19.6839 14.5587 19.1213 15.1213C18.5587 15.6839 17.7956 16 17 16H16V20H4V16H3C2.20435 16 1.44129 15.6839 0.87868 15.1213C0.31607 14.5587 0 13.7956 0 13L0 7C0 6.20435 0.31607 5.44129 0.87868 4.87868C1.44129 4.31607 2.20435 4 3 4H4ZM6 18H14V11H6V18ZM6 4H14V2H6V4Z"
              fill="#03267A"
            />
          </svg>
          {{ $t("multidisciplinary_board.lbl_print") }}
        </button>
        <!-- <button
          v-if="!form.sign_by"
          class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
          :disabled="loading"
          @click="handleSignature"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 512 512"
            fill="#03267A"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1_5)">
              <path
                d="M18.3495 -0.131664C19.3245 -0.134749 19.3245 -0.134749 20.3192 -0.137896C22.5123 -0.143593 24.7054 -0.142115 26.8985 -0.140695C28.4808 -0.143283 30.063 -0.146302 31.6452 -0.149716C36.0051 -0.157816 40.3649 -0.159596 44.7248 -0.160335C49.4222 -0.162186 54.1197 -0.169747 58.8171 -0.176501C69.0939 -0.190122 79.3706 -0.196149 89.6474 -0.200559C96.0612 -0.203325 102.475 -0.20757 108.889 -0.212086C126.639 -0.224303 144.388 -0.234623 162.138 -0.238012C163.274 -0.238231 164.411 -0.238451 165.581 -0.238678C166.721 -0.238897 167.86 -0.239116 169.034 -0.239341C171.342 -0.239785 173.651 -0.240233 175.959 -0.240683C177.677 -0.241016 177.677 -0.241016 179.429 -0.241356C197.99 -0.245312 216.552 -0.262804 235.113 -0.286131C254.158 -0.309875 273.204 -0.322377 292.249 -0.323546C302.947 -0.324466 313.644 -0.330253 324.342 -0.348415C333.45 -0.363823 342.559 -0.36899 351.667 -0.360701C356.316 -0.356778 360.964 -0.357756 365.613 -0.37178C369.867 -0.384496 374.122 -0.383386 378.376 -0.371188C379.916 -0.369219 381.457 -0.372349 382.997 -0.381051C385.089 -0.392124 387.181 -0.384693 389.273 -0.372643C390.436 -0.373242 391.598 -0.37384 392.796 -0.374456C398.913 0.340433 403.152 3.30346 407 8.01568C409.517 14.4879 409.306 20.9074 409.319 27.7826C409.329 29.054 409.339 30.3255 409.349 31.6355C409.377 35.1045 409.392 38.5736 409.405 42.0427C409.42 45.6746 409.447 49.3065 409.473 52.9384C409.52 59.8081 409.556 66.6778 409.589 73.5475C409.628 81.3718 409.677 89.196 409.727 97.0203C409.831 113.108 409.92 129.196 410 145.284C410.877 144.389 411.755 143.494 412.659 142.572C415.927 139.243 419.206 135.923 422.488 132.606C423.905 131.172 425.319 129.734 426.73 128.294C428.763 126.22 430.807 124.156 432.852 122.094C433.477 121.452 434.102 120.81 434.746 120.149C439.67 115.214 444.198 111.791 451.438 111.781C452.766 111.752 452.766 111.752 454.121 111.722C462.902 113.238 468.696 120.508 474.676 126.56C475.692 127.578 476.708 128.596 477.725 129.614C479.846 131.738 481.961 133.868 484.072 136.001C486.774 138.732 489.488 141.451 492.206 144.167C494.302 146.264 496.393 148.366 498.483 150.47C499.482 151.475 500.482 152.478 501.484 153.48C502.881 154.88 504.271 156.287 505.661 157.695C506.849 158.891 506.849 158.891 508.06 160.112C512.345 164.982 512.432 169.098 512.316 175.429C511.746 180.689 509.221 183.256 505.438 186.677C502.174 188.941 499.575 189.54 495.688 189.62C494.58 189.659 494.58 189.659 493.449 189.699C486.342 188.745 481.957 183.715 477.195 178.838C476.471 178.108 475.747 177.378 475.002 176.627C472.702 174.306 470.414 171.975 468.125 169.644C466.563 168.064 465.001 166.485 463.438 164.906C459.617 161.045 455.806 157.175 452 153.299C447.176 157.331 442.628 161.546 438.198 166.006C437.551 166.654 436.904 167.301 436.237 167.968C434.087 170.121 431.94 172.278 429.793 174.434C428.246 175.985 426.698 177.536 425.15 179.086C420.96 183.284 416.774 187.484 412.587 191.686C408.208 196.08 403.825 200.472 399.443 204.864C391.15 213.176 382.86 221.491 374.571 229.806C367.946 236.452 361.32 243.096 354.693 249.74C354.226 250.208 353.759 250.676 353.278 251.159C350.934 253.508 348.59 255.858 346.247 258.207C326.828 277.674 307.413 297.145 288 316.618C288.406 317.091 288.813 317.563 289.231 318.049C290.035 318.986 290.035 318.986 290.856 319.941C291.386 320.558 291.916 321.175 292.462 321.81C296.793 326.939 299.065 330.94 299 337.66C298.242 343.84 295.547 346.481 290.973 350.301C286.982 353.104 282.71 353.288 278 352.689C272.057 350.741 268.148 347.241 264 342.669C258.749 344.914 256.464 348.654 254 353.691C251.579 360.825 250.164 368.306 249 375.734C251.816 375.162 254.627 374.575 257.438 373.98C258.221 373.823 259.004 373.665 259.811 373.503C260.594 373.335 261.377 373.167 262.184 372.994C262.891 372.847 263.598 372.7 264.326 372.549C272.34 370.083 277.842 366.604 283.679 360.607C284.396 359.89 285.114 359.173 285.853 358.435C288.239 356.045 290.607 353.638 292.975 351.231C294.688 349.508 296.402 347.787 298.117 346.066C301.801 342.366 305.477 338.659 309.147 334.944C314.458 329.568 319.785 324.208 325.116 318.851C333.774 310.15 342.422 301.44 351.063 292.722C351.837 291.94 351.837 291.94 352.627 291.143C353.673 290.088 354.718 289.033 355.763 287.979C356.281 287.456 356.799 286.933 357.333 286.395C357.852 285.871 358.371 285.348 358.905 284.809C364.667 278.995 370.432 273.183 376.198 267.372C376.973 266.592 376.973 266.592 377.763 265.795C386.379 257.113 395.001 248.436 403.627 239.763C408.941 234.418 414.25 229.068 419.551 223.71C423.612 219.605 427.681 215.507 431.753 211.412C433.42 209.733 435.084 208.051 436.746 206.367C439.016 204.067 441.294 201.776 443.575 199.487C444.23 198.82 444.884 198.152 445.558 197.464C451.228 191.81 456.674 187.669 465 187.366C469.674 188.417 473.265 190.384 477 193.378C482.381 201.929 481.243 212.258 481.25 221.996C481.251 222.783 481.251 223.57 481.252 224.381C481.205 259.026 473.109 290.08 450 316.618C449.433 317.284 448.866 317.949 448.281 318.634C438.125 329.666 424.38 337.81 411.37 344.984C400.692 350.912 394.623 357.75 390.563 369.409C388.517 375.081 386.262 378.697 381 381.746C375.833 383.471 370.894 383.404 365.75 381.62C361.919 379.003 359.098 375.931 357 371.726C355.121 358.16 360.67 346.872 368.438 336.157C374.842 327.877 381.667 321.757 390.75 316.618C392.526 315.581 394.301 314.541 396.074 313.499C396.923 313.004 397.772 312.508 398.646 311.998C420.954 298.817 435.782 282.831 443.274 257.538C444.07 254.203 444.535 250.88 445 247.483C437.686 254.788 430.375 262.096 423.067 269.407C419.673 272.803 416.278 276.197 412.881 279.59C409.598 282.868 406.318 286.149 403.039 289.432C401.792 290.679 400.545 291.925 399.296 293.171C397.538 294.925 395.782 296.684 394.027 298.442C393.519 298.948 393.012 299.453 392.488 299.973C389.752 302.723 387.15 305.545 384.616 308.483C380.949 312.722 377.067 316.707 373.112 320.675C372.357 321.437 371.601 322.199 370.823 322.984C368.347 325.48 365.867 327.971 363.387 330.462C362.534 331.319 361.681 332.176 360.803 333.059C356.294 337.592 351.783 342.121 347.269 346.648C342.625 351.306 337.991 355.974 333.36 360.643C329.778 364.251 326.189 367.851 322.599 371.45C320.888 373.168 319.18 374.887 317.474 376.61C315.082 379.024 312.68 381.428 310.276 383.83C309.584 384.532 308.893 385.235 308.18 385.958C292.6 401.439 272.072 408.851 250.355 410.117C239.543 410.787 233.811 412.784 226 420.822C213.356 432.759 213.356 432.759 204.875 433.284C196.157 432.969 188.01 429.872 181 424.83C176.897 424.83 175.642 425.332 172.125 427.147C156.748 434.378 140.146 434.304 124 429.84C121.97 428.944 119.965 427.99 118 426.959C114.567 425.198 114.567 425.198 110.824 425.037C108.658 425.745 108.658 425.745 106.516 426.728C98.8793 430.09 90.3238 432.28 82 432.845C80.9114 432.94 80.9114 432.94 79.8008 433.037C74.0169 433.342 69.765 432.186 65 428.838C60.3249 423.913 59.6993 419.879 59.7852 413.311C60.1928 408.551 61.9731 405.765 65.375 402.536C70.1436 399.351 74.5296 398.425 80.1875 397.714C84.7469 397.257 84.7469 397.257 89 395.773C88.7834 395.184 88.5669 394.595 88.3438 393.988C81.249 371.083 86.5774 345.401 97.3125 324.615C104.193 312.438 113.589 301.067 127.332 296.869C138.414 294.176 148.683 296.169 158.379 302.023C166.531 307.787 171.856 315.877 174 325.636C176.365 351.962 166.451 372.597 150.543 392.928C149.106 394.644 147.609 396.223 146 397.777C152.11 397.505 156.096 396.745 161 392.767C161.519 392.347 162.039 391.928 162.574 391.495C164.53 389.117 164.83 386.942 165.438 383.937C166.978 377.374 168.676 373.461 174.188 369.346C178.387 367.188 182.38 367.024 187 367.718C191.696 369.437 194.837 371.86 198 375.734C200.037 380.837 200.387 385.974 200.754 391.409C200.862 393.787 200.862 393.787 202 395.773C206.771 393.309 210.419 390.492 213 385.753C214.94 378.669 215.455 371.363 216.121 364.07C218.429 340.67 229.462 324.181 247.157 309.616C248.351 308.642 249.547 307.671 250.744 306.701C265.119 295.035 278.96 282.807 292.657 270.353C299.68 263.986 306.706 257.677 314.125 251.773C341.232 230.13 353.457 211.949 374 181.354C374.33 132.749 374.66 84.1444 375 34.0666C262.14 34.0666 149.28 34.0666 33 34.0666C33 181.204 33 328.341 33 479.937C145.86 479.937 258.72 479.937 375 479.937C375 453.486 375 427.034 375 399.781C379.765 390.231 379.766 390.231 385 387.757C390.408 386.31 395.063 386.421 400.211 388.681C405.232 391.713 407.548 396.203 409 401.785C409.282 404.945 409.284 408.09 409.275 411.262C409.282 412.666 409.282 412.666 409.29 414.098C409.304 417.182 409.303 420.266 409.301 423.35C409.305 425.502 409.309 427.653 409.314 429.804C409.321 434.31 409.321 438.816 409.316 443.322C409.31 449.085 409.327 454.848 409.35 460.612C409.365 465.054 409.366 469.496 409.363 473.939C409.363 476.063 409.368 478.187 409.378 480.312C409.391 483.287 409.384 486.263 409.372 489.238C409.38 490.109 409.388 490.979 409.396 491.876C409.337 498.753 408.316 504.206 403.851 509.574C400.358 512.546 398.776 512.629 394.248 512.636C393.245 512.648 393.245 512.648 392.22 512.66C389.974 512.68 387.728 512.665 385.481 512.65C383.856 512.657 382.231 512.666 380.606 512.678C376.136 512.702 371.667 512.696 367.198 512.684C362.379 512.677 357.56 512.699 352.741 512.716C343.3 512.746 333.858 512.749 324.417 512.741C316.744 512.736 309.072 512.739 301.4 512.748C299.763 512.75 299.763 512.75 298.093 512.753C295.877 512.755 293.661 512.758 291.444 512.761C270.649 512.785 249.855 512.778 229.06 512.76C210.027 512.745 190.994 512.769 171.961 512.812C152.427 512.856 132.894 512.874 113.36 512.864C102.39 512.858 91.4193 512.863 80.4488 512.895C71.1099 512.921 61.7714 512.924 52.4326 512.894C47.6661 512.879 42.9003 512.876 38.1339 512.904C33.7718 512.928 29.4111 512.921 25.0492 512.887C23.4698 512.881 21.8904 512.886 20.3111 512.904C8.50379 513.032 8.50379 513.032 4.74277 510.451C0.420938 505.532 -0.146373 501.476 -0.134222 495.069C-0.136574 494.238 -0.138926 493.407 -0.14135 492.551C-0.148064 489.736 -0.147582 486.92 -0.147173 484.105C-0.15047 482.078 -0.154195 480.052 -0.158314 478.025C-0.168359 472.432 -0.172055 466.839 -0.174704 461.246C-0.178599 455.223 -0.188178 449.2 -0.196917 443.178C-0.215767 429.309 -0.22594 415.441 -0.234377 401.573C-0.238581 394.722 -0.243803 387.872 -0.249062 381.022C-0.266953 357.58 -0.281949 334.139 -0.289381 310.698C-0.289856 309.226 -0.290333 307.754 -0.29081 306.282C-0.291046 305.552 -0.291281 304.822 -0.291525 304.07C-0.292726 300.371 -0.293941 296.672 -0.295166 292.973C-0.295406 292.239 -0.295647 291.505 -0.295895 290.749C-0.303789 266.943 -0.327224 243.138 -0.359722 219.332C-0.394003 194.174 -0.41373 169.017 -0.417025 143.859C-0.417442 141.099 -0.417921 138.338 -0.418447 135.578C-0.418571 134.898 -0.418694 134.218 -0.418821 133.518C-0.421155 122.568 -0.436828 111.619 -0.457291 100.67C-0.477525 89.668 -0.482704 78.6664 -0.47352 67.6648C-0.468961 61.7021 -0.470958 55.7396 -0.490282 49.7769C-0.507808 44.3219 -0.507002 38.8673 -0.491385 33.4124C-0.488992 31.4354 -0.493414 29.4584 -0.505213 27.4815C-0.520228 24.8002 -0.510731 22.1201 -0.494986 19.4388C-0.505208 18.6659 -0.515431 17.893 -0.525963 17.0967C-0.459271 11.916 0.7553 9.00942 4 5.00981C8.77866 0.688918 12.0019 -0.124842 18.3495 -0.131664ZM137 329.644C126.265 337.326 121.556 350.715 119.367 363.358C119.06 366.168 118.894 368.842 118.938 371.663C118.958 373.02 118.979 374.377 119 375.734C124.177 371.726 127.826 367.63 131.188 362.02C131.616 361.316 132.045 360.612 132.486 359.886C137.039 352.222 141.898 342.876 141 333.652C139.249 331.056 139.249 331.056 137 329.644Z"
              />
              <path
                d="M87.1318 78.021C87.977 78.0171 88.8223 78.0133 89.6932 78.0093C90.6219 78.0102 91.5507 78.0111 92.5076 78.0119C93.9875 78.0075 93.9875 78.0075 95.4972 78.0029C98.8182 77.9942 102.139 77.9927 105.46 77.9912C107.835 77.9866 110.21 77.9815 112.585 77.9761C119.048 77.963 125.511 77.9565 131.973 77.9521C136.009 77.9493 140.044 77.9451 144.079 77.9406C155.251 77.9283 166.422 77.918 177.594 77.9146C178.667 77.9143 178.667 77.9143 179.761 77.914C180.478 77.9137 181.194 77.9135 181.933 77.9133C183.385 77.9129 184.838 77.9124 186.29 77.912C187.371 77.9116 187.371 77.9116 188.473 77.9113C200.148 77.9073 211.822 77.8898 223.496 77.8665C235.481 77.8428 247.466 77.8303 259.452 77.8291C266.181 77.8282 272.91 77.8224 279.64 77.8042C285.969 77.7878 292.298 77.7855 298.627 77.7943C300.951 77.7951 303.276 77.7907 305.6 77.7809C308.771 77.7682 311.941 77.774 315.111 77.7845C316.495 77.7723 316.495 77.7723 317.906 77.76C324.58 77.8117 328.79 79.045 333.75 83.7887C336.613 87.5601 337.814 91.469 338 96.1879C337.314 100.994 335.831 104.865 332.188 108.149C325.956 112.189 320.499 112.511 313.297 112.48C312.326 112.484 311.354 112.488 310.353 112.492C307.102 112.502 303.85 112.498 300.598 112.494C298.265 112.499 295.933 112.504 293.6 112.51C287.265 112.523 280.931 112.524 274.596 112.521C268.639 112.52 262.681 112.526 256.724 112.532C244.203 112.543 231.683 112.541 219.162 112.534C207.716 112.529 196.269 112.541 184.823 112.56C173.061 112.579 161.3 112.587 149.539 112.584C142.939 112.582 136.339 112.584 129.739 112.598C123.532 112.611 117.326 112.609 111.119 112.596C108.842 112.593 106.565 112.596 104.288 112.604C101.178 112.615 98.0676 112.607 94.9571 112.594C94.0584 112.602 93.1598 112.609 92.2339 112.617C86.2418 112.565 80.0954 112.025 75.4376 107.794C71.0292 102.708 70.6505 98.3852 70.7188 91.9061C71.2454 86.7908 73.8916 84.1647 77.5625 80.8454C80.8107 78.5923 83.2754 78.0276 87.1318 78.021Z"
              />
              <path
                d="M92.0579 149.785C93.554 149.775 93.554 149.775 95.0804 149.766C98.4145 149.75 101.748 149.762 105.082 149.775C107.476 149.77 109.869 149.762 112.263 149.754C118.084 149.737 123.906 149.74 129.727 149.751C134.459 149.76 139.192 149.762 143.924 149.757C144.935 149.756 144.935 149.756 145.967 149.755C147.337 149.754 148.707 149.753 150.076 149.751C162.913 149.74 175.749 149.753 188.585 149.775C199.593 149.793 210.601 149.79 221.608 149.771C234.4 149.75 247.191 149.741 259.982 149.753C261.347 149.755 262.711 149.756 264.076 149.757C264.747 149.758 265.419 149.758 266.111 149.759C270.836 149.763 275.561 149.757 280.286 149.747C286.649 149.736 293.011 149.744 299.374 149.767C301.71 149.772 304.045 149.771 306.38 149.762C309.568 149.751 312.755 149.765 315.942 149.785C316.866 149.776 317.791 149.767 318.743 149.758C324.671 149.83 328.137 150.848 333 154.301C336.765 158.67 338.099 162.652 338 168.329C337.063 173.366 335.627 176.718 332 180.352C326.691 183.765 322.16 183.786 316.062 183.747C315.066 183.752 314.069 183.757 313.042 183.763C309.705 183.777 306.369 183.77 303.032 183.763C300.638 183.769 298.245 183.776 295.851 183.784C290.026 183.8 284.201 183.802 278.377 183.797C273.641 183.793 268.906 183.794 264.171 183.799C263.497 183.8 262.822 183.801 262.127 183.802C260.757 183.803 259.387 183.805 258.017 183.806C245.174 183.82 232.331 183.815 219.488 183.803C207.744 183.793 195.999 183.806 184.255 183.83C172.189 183.855 160.124 183.864 148.059 183.857C141.287 183.854 134.516 183.856 127.745 183.874C121.378 183.889 115.011 183.885 108.644 183.866C106.307 183.863 103.97 183.866 101.633 183.876C98.4434 183.89 95.2545 183.878 92.0646 183.86C91.1397 183.87 90.2148 183.88 89.2618 183.889C83.3328 183.822 79.8529 182.824 75 179.35C71.0452 174.372 70.3527 170.297 70.6211 163.973C71.2238 159.745 72.3212 157.674 75 154.301C80.7392 150.194 85.1141 149.717 92.0579 149.785Z"
              />
              <path
                d="M97.396 221.157C98.6422 221.152 99.8885 221.147 101.172 221.142C104.58 221.13 107.987 221.128 111.394 221.13C114.244 221.131 117.094 221.127 119.944 221.122C126.672 221.111 133.4 221.11 140.128 221.116C147.055 221.122 153.981 221.11 160.908 221.089C166.867 221.071 172.827 221.065 178.786 221.068C182.34 221.07 185.894 221.067 189.447 221.053C193.413 221.038 197.379 221.048 201.345 221.059C202.513 221.052 203.681 221.044 204.885 221.036C212.688 221.087 218.881 221.585 224.875 227.069C227.892 231.87 229.435 236.124 228.691 241.84C227.108 247.693 224.08 251.258 219 254.497C215.934 255.521 213.842 255.63 210.63 255.64C208.959 255.648 208.959 255.648 207.253 255.657C206.03 255.658 204.806 255.659 203.546 255.66C202.258 255.665 200.97 255.67 199.643 255.676C196.107 255.689 192.572 255.695 189.037 255.7C186.827 255.703 184.618 255.707 182.409 255.711C175.494 255.725 168.58 255.735 161.665 255.738C153.687 255.743 145.709 255.76 137.731 255.79C131.562 255.811 125.393 255.821 119.224 255.823C115.54 255.824 111.857 255.83 108.174 255.847C104.063 255.867 99.9531 255.863 95.8425 255.856C94.6252 255.865 93.4078 255.875 92.1535 255.884C85.5464 255.851 80.4253 255.697 75.3555 250.955C70.7473 244.917 70.4155 240.985 71 233.456C72.6418 228.694 74.7989 226.177 79 223.436C84.9266 220.726 91.0149 221.144 97.396 221.157Z"
              />
            </g>
            <defs>
              <clipPath id="clip0_1_5">
                <rect width="512" height="512" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {{ $t("Ký xác nhận") }}
        </button>-->
        <button
          v-if="!form.sign_by"
          class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
          :disabled="loading"
          @click="ModalUpdate(true)"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.75 8.99995C15.5511 8.99995 15.3603 9.07897 15.2197 9.21962C15.079 9.36028 15 9.55104 15 9.74995V14.25C15 14.4489 14.921 14.6396 14.7803 14.7803C14.6397 14.9209 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.9209 3.21967 14.7803C3.07902 14.6396 3 14.4489 3 14.25V3.74995C3 3.55104 3.07902 3.36028 3.21967 3.21962C3.36032 3.07897 3.55109 2.99995 3.75 2.99995H8.25C8.44891 2.99995 8.63968 2.92094 8.78033 2.78028C8.92098 2.63963 9 2.44887 9 2.24995C9 2.05104 8.92098 1.86028 8.78033 1.71962C8.63968 1.57897 8.44891 1.49995 8.25 1.49995H3.75C3.15326 1.49995 2.58097 1.73701 2.15901 2.15896C1.73705 2.58092 1.5 3.15322 1.5 3.74995V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.8409C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.8409C16.2629 15.419 16.5 14.8467 16.5 14.25V9.74995C16.5 9.55104 16.421 9.36028 16.2803 9.21962C16.1397 9.07897 15.9489 8.99995 15.75 8.99995ZM4.5 9.56995V12.75C4.5 12.9489 4.57902 13.1396 4.71967 13.2803C4.86032 13.4209 5.05109 13.5 5.25 13.5H8.43C8.5287 13.5005 8.62655 13.4816 8.71793 13.4443C8.80931 13.407 8.89242 13.352 8.9625 13.2825L14.1525 8.08495L16.2825 5.99995C16.3528 5.93023 16.4086 5.84728 16.4467 5.75589C16.4847 5.66449 16.5043 5.56646 16.5043 5.46745C16.5043 5.36845 16.4847 5.27042 16.4467 5.17902C16.4086 5.08763 16.3528 5.00468 16.2825 4.93495L13.1025 1.71745C13.0328 1.64716 12.9498 1.59136 12.8584 1.55329C12.767 1.51521 12.669 1.49561 12.57 1.49561C12.471 1.49561 12.373 1.51521 12.2816 1.55329C12.1902 1.59136 12.1072 1.64716 12.0375 1.71745L9.9225 3.83995L4.7175 9.03745C4.64799 9.10753 4.593 9.19065 4.55567 9.28202C4.51835 9.3734 4.49943 9.47125 4.5 9.56995V9.56995ZM12.57 3.30745L14.6925 5.42995L13.6275 6.49495L11.505 4.37245L12.57 3.30745ZM6 9.87745L10.4475 5.42995L12.57 7.55245L8.1225 12H6V9.87745Z"
              fill="#03267A"
            />
          </svg>
          {{ $t("multidisciplinary_board.lbl_modify_short") }}
        </button>
      </template>

      <div
        class="text-black mx-2 fs-14 fw-500 h-4 cursor-pointer mb-3"
        @click="backList"
        v-if="!loading"
      >
        <svg
          width="40"
          height="46"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.6276 24.7096L33.6976 17.6376C33.8887 17.4531 34.041 17.2324 34.1458 16.9884C34.2507 16.7444 34.3058 16.4819 34.3081 16.2164C34.3104 15.9508 34.2598 15.6874 34.1593 15.4416C34.0587 15.1959 33.9102 14.9725 33.7224 14.7848C33.5346 14.597 33.3113 14.4485 33.0655 14.3479C32.8198 14.2473 32.5564 14.1967 32.2908 14.1991C32.0253 14.2014 31.7628 14.2565 31.5188 14.3613C31.2748 14.4662 31.0541 14.6185 30.8696 14.8096L23.7976 21.8796L16.7276 14.8096C16.5431 14.6185 16.3225 14.4662 16.0784 14.3613C15.8344 14.2565 15.572 14.2014 15.3064 14.1991C15.0409 14.1967 14.7775 14.2473 14.5317 14.3479C14.2859 14.4485 14.0626 14.597 13.8748 14.7848C13.6871 14.9725 13.5386 15.1959 13.438 15.4416C13.3374 15.6874 13.2868 15.9508 13.2891 16.2164C13.2914 16.4819 13.3466 16.7444 13.4514 16.9884C13.5563 17.2324 13.7086 17.4531 13.8996 17.6376L20.9696 24.7076L13.8996 31.7796C13.7086 31.964 13.5563 32.1847 13.4514 32.4287C13.3466 32.6728 13.2914 32.9352 13.2891 33.2007C13.2868 33.4663 13.3374 33.7297 13.438 33.9755C13.5386 34.2213 13.6871 34.4446 13.8748 34.6323C14.0626 34.8201 14.2859 34.9686 14.5317 35.0692C14.7775 35.1698 15.0409 35.2204 15.3064 35.2181C15.572 35.2157 15.8344 35.1606 16.0784 35.0558C16.3225 34.9509 16.5431 34.7986 16.7276 34.6076L23.7976 27.5376L30.8696 34.6076C31.0541 34.7986 31.2748 34.9509 31.5188 35.0558C31.7628 35.1606 32.0253 35.2157 32.2908 35.2181C32.5564 35.2204 32.8198 35.1698 33.0655 35.0692C33.3113 34.9686 33.5346 34.8201 33.7224 34.6323C33.9102 34.4446 34.0587 34.2213 34.1593 33.9755C34.2598 33.7297 34.3104 33.4663 34.3081 33.2007C34.3058 32.9352 34.2507 32.6728 34.1458 32.4287C34.041 32.1847 33.8887 31.964 33.6976 31.7796L26.6276 24.7076V24.7096Z"
            fill="black"
          />
        </svg>
      </div>
    </div>

    <div v-if="!$route.query.id_treatment">
      <div class="flex items-center justify-center mb-4">
        <div class="mx-2 font-bold">Chọn thời gian in</div>
        <div class="w-96">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
        </div>
        <button
          class="btn bg-pri bd-pri text-white px-4 mx-2"
          @click="onSubmitDateRange"
        >
          Áp dụng bộ lọc
        </button>
        <button
          :disabled="loading"
          class="btn bg-pri bd-pri text-white px-4 mx-2"
          @click="onPrintNe()"
        >
          <span v-if="loading" class="loading mr-2">
            <span class="spinner-border w-3 h-3" role="status">
              <span class="visually-hidden">Loading...</span>
            </span>
          </span>
          <span>{{ $t("multidisciplinary_board.lbl_print") }}</span>
        </button>
      </div>
    </div>

    <div class="py-2 mb-3">
      <h3
        class="uppercase font-bold mb-2 border-b-2 border-t-0 border-r-0 border-l-0 border-solid border-gray-200"
      >
        <span>Chỉ số sinh hiệu</span>
      </h3>
      <div class="row fs-16">
        <div class="col-lg-3 mb-2">
          <label class="mr-1">Nhiệt độ (&#8451;):</label>
          <span class="font-medium"
            >{{ metaData.NhietDo ? metaData.NhietDo : "_" }}&#8451;</span
          >
        </div>
        <div class="col-lg-3 mb-2">
          <label class="mr-1">Nhịp thở (lần/phút):</label>
          <span class="font-medium">{{
            metaData.NhipTho ? metaData.NhipTho : "_"
          }}</span>
        </div>
        <div class="col-lg-3 mb-2">
          <label class="mr-1">Mạch (lần/phút):</label>
          <span class="font-medium">{{
            metaData.NhipTim ? metaData.NhipTim : "_"
          }}</span>
        </div>
        <div class="col-lg-3 mb-2">
          <label class="mr-1">SPO2:</label>
          <span class="font-medium">{{
            metaData.SPO2 ? metaData.SPO2 : "_"
          }}</span>
        </div>
        <div class="col-lg-3 mb-2">
          <label class="mr-1">Huyết áp (mmHg):</label>
          <span class="font-medium">
            {{
              `${metaData.HuyetAp_Low ? metaData.HuyetAp_Low : "_"} / ${
                metaData.HuyetAp_High ? metaData.HuyetAp_High : "_"
              }`
            }}
          </span>
        </div>
        <div class="col-lg-3 mb-2">
          <label class="mr-1">Creatinin (µmol/l):</label>
          <span class="font-medium">{{
            metaData.Creatinin ? metaData.Creatinin : "_"
          }}</span>
        </div>
        <div class="col-lg-3 mb-2">
          <label class="mr-1">Chiều cao (cm):</label>
          <span class="font-medium">{{
            metaData.ChieuCao ? metaData.ChieuCao : "_"
          }}</span>
        </div>
        <div class="col-lg-3 mb-2">
          <label class="mr-1">Cân nặng (kg):</label>
          <span class="font-medium">{{
            metaData.CanNang ? metaData.CanNang : "_"
          }}</span>
        </div>
      </div>
    </div>

    <div class="py-2 border" ref="documentPrint">
      <div id="TreatmentViewDetail" class="hodo-print mx-auto text-black">
        <div class="flex">
          <div class="uppercase">
            <div class="fs-17">
              {{
                $globalClinic && $globalClinic.organization
                  ? $globalClinic.organization.authority_in_charge
                  : ""
              }}
            </div>
            <div class="fs-17">
              {{
                $globalClinic && $globalClinic.organization
                  ? $globalClinic.organization.name
                  : ""
              }}
            </div>
            <div class="fs-17">
              {{ $globalClinic ? $globalClinic.name : "" }}
            </div>
          </div>

          <div class="ml-auto">
            <div class="fs-17">
              Mã bệnh án:
              <span>........................</span>
            </div>
            <div class="fs-17">
              Số HS:
              <span>{{ person.ref_id || "........................" }}</span>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div class="fs-24 font-bold uppercase">Tờ Điều Trị</div>
          <div class="fs-17 mt-1">Số: .......</div>
        </div>
        <div class="block mt-3">
          <div class="col-7">
            <div class="fs-18">
              Họ tên người bệnh:
              <span class="font-bold fs-18">{{ person.name }}</span>
            </div>
            <div class="flex">
              <div class="fs-18">
                Buồng:
                <span
                  class="font-normal fs-18"
                  v-show="person.admission_room"
                  >{{ person.admission_room }}</span
                >
              </div>
              <div class="ml-5 fs-18">
                Giường:
                <span class="font-normal fs-18" v-show="person.admission_bed">
                  {{ person.admission_bed }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="flex justify-between">
              <div class="fs-18">Năm sinh: {{ getYear() }}</div>
              <div class="fs-18">Giới tính: {{ getGender() }}</div>
            </div>
          </div>
          <div class="fs-18">Chẩn đoán: {{ getTreatDeptMain() }}</div>
        </div>
        <div class="mt-4 table-width-full" v-if="dataTable.length">
          <el-table
            :span-method="arraySpanMethod"
            :data="dataTable"
            :default-sort="{ prop: 'date', order: 'descending' }"
            row-class-name="text-black fs-18"
            header-cell-class-name="text-black fs-16 font-bold text-center px-0 align-middle"
            border
          >
            <el-table-column
              label="NGÀY THÁNG"
              width="110px"
              class-name="p-0 align-top leading-none"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.date"
                  class="leading-tight py-1 text-center fs-18"
                  v-html="getDateTime(scope.row)"
                ></div>
                <div v-if="scope.row.appt_date_only" class="py-1 fs-18">
                  <label class="mr-1 ml-1 font-bold fs-18">Ngày hẹn:</label>
                  <span class="font-normal fs-18">
                    <span>
                      {{
                        scope.row.appt_date_only
                          ? appUtils.formatDate(scope.row.appt_date_only)
                          : ""
                      }}
                    </span>
                    <template v-if="scope.row.user_name">
                      <span class="mx-1">-</span>
                      <span>
                        Lịch hẹn với:
                        <strong>{{ `Bs. ${scope.row.user_name}` }}</strong>
                      </span>
                    </template>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="DIỄN BIẾN BỆNH" class-name="p-0 align-top">
              <template slot-scope="scope">
                <template v-if="scope.row.pdf_url">
                  <div class="text-center fs-18">
                    <a
                      :href="scope.row.pdf_url ? scope.row.pdf_url : '#'"
                      target="_blank"
                      >Xem phiếu</a
                    >
                  </div>
                </template>
                <template v-else>
                  <div class="mb-2 p-1" v-if="scope.row.examination">
                    <div
                      class="content-size fs-18 whitespace-pre-wrap"
                      v-html="scope.row.examination"
                    ></div>
                  </div>
                  <div class="mb-2 p-1" v-if="scope.row.disease_progression">
                    <div
                      class="content-size fs-18 whitespace-pre-wrap"
                      v-html="scope.row.disease_progression"
                    ></div>
                  </div>
                  <div class="p-1" v-if="scope.row.conclusion">
                    <div class="font-bold fs-18">Kết luận:</div>
                    <div
                      class="content-size fs-18 whitespace-pre-wrap"
                      v-html="scope.row.conclusion"
                    ></div>
                  </div>
                </template>
                <div class="mb-3 p-1" v-if="scope.row.solution">
                  <div class="font-bold fs-18">Xử trí:</div>
                  <div
                    class="content-size fs-18 whitespace-pre-wrap"
                    v-html="scope.row.solution"
                  ></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Y LỆNH" class-name="p-0 align-top">
              <template slot-scope="scope">
                <div
                  class="mb-2 p-1"
                  v-if="
                    scope.row.indication_labs && scope.row.indication_labs.length > 0
                  "
                >
                  <div class="font-bold fs-18">Chỉ định xét nghiệm:</div>
                  <div
                    class="fs-18 whitespace-pre-wrap"
                    v-for="item in scope.row.indication_labs"
                    :key="item.id"
                  >
                    <div> {{ item.vimes_original_name || item.name.replace(/\r/g, "\n") }}</div>
                    <ul v-if="item.indications && item.indications.length > 0">
                      <li v-for="indication in item.indications" :key="indication.id">
                        {{ indication.name }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="mb-2 p-1"
                  v-if="scope.row.indication_pacs && scope.row.indication_pacs.length > 0"
                >
                  <div class="font-bold fs-18">Chẩn đoán hình ảnh:</div>
                  <div
                    class="fs-18 whitespace-pre-wrap"
                    v-for="item in scope.row.indication_pacs"
                    :key="item.id"
                  >
                    <div> {{ item.vimes_original_name || item.name.replace(/\r/g, "\n") }}</div>
                    <ul v-if="item.indications && item.indications.length > 0">
                      <li v-for="indication in item.indications" :key="indication.id">
                        {{ indication.name }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="mb-2 p-1 fs-18"
                  v-if="
                    scope.row.medicines &&
                    scope.row.medicines.find((x) => x.type === 1) &&
                    scope.row.medicines.length > 0
                  "
                >
                  <div class="font-bold fs-18">Thuốc:</div>
                  <div v-for="item in scope.row.medicines" :key="item.id">
                    <div
                      v-if="item.type === 1"
                      class="fs-18 whitespace-pre-wrap"
                    >
                      {{ item.name.replace(/\r/g, "\n") }}
                    </div>
                    <ul v-if="item.type === 1 && item.person_medicine && item.person_medicine.length">
                      <li v-for="med in item.person_medicine" :key="med.id">
                        {{ med.name.replace(/\r/g, '\n') }} <br> {{ med.doctor_note }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="mb-2 p-1 fs-18"
                  v-if="
                    scope.row.medicines &&
                    scope.row.medicines.find((x) => x.type === 2) &&
                    scope.row.medicines.length > 0
                  "
                >
                  <div class="font-bold fs-18">Thuốc tự túc:</div>
                  <div v-for="item in scope.row.medicines" :key="item.id">
                    <div
                      v-if="item.type === 2"
                      class="fs-18 whitespace-pre-wrap"
                    >
                      {{ item.name.replace(/\r/g, "\n") }}
                    </div>
                    <ul v-if="item.type === 2 && item.person_medicine && item.person_medicine.length">
                      <li v-for="med in item.person_medicine" :key="med.id">
                        {{ med.name.replace(/\r/g, "\n") }} <br> {{ med.doctor_note }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="mb-2 p-1 fs-18"
                  v-if="scope.row.materials && scope.row.materials.length > 0"
                >
                  <div class="font-bold fs-18">Vật tư:</div>
                  <div v-for="item in scope.row.materials" :key="item.id">
                    <div class="fs-18 whitespace-pre-wrap">
                      {{ item.name.replace(/\r/g, "\n") }}
                    </div>
                    <ul v-if="item.person_materials && item.person_materials.length">
                      <li v-for="med in item.person_materials" :key="med.id">
                        {{ med.name.replace(/\r/g, "\n") }} <br> {{ med.route_of_use }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="mb-2 p-1" v-if="scope.row.diet_order">
                  <div class="font-bold fs-18">Chế độ ăn:</div>
                  <div
                    class="content-size fs-18 whitespace-pre-wrap"
                    v-html="scope.row.diet_order"
                  ></div>
                </div>
                <div class="mb-2 p-1" v-if="scope.row.care_order">
                  <div class="font-bold fs-18">Chăm sóc:</div>
                  <div
                    class="content-size fs-18 whitespace-pre-wrap"
                    v-html="scope.row.care_order"
                  ></div>
                </div>

                <div class="text-center font-bold fs-18">Bác sĩ điều trị</div>
                <div class="mt-16 text-center font-bold fs-18">
                  <!-- {{person.treat_doctor}} -->
                  Bác sĩ {{ getDoctorData(scope.row) }}
                  <template v-if="scope.row.sign_by">
                    <div class="block text-center font-normal italic">
                      <span class="mr-1" style="font-size: 14px !important">{{
                        appUtils.formatDateTime(scope.row.sign_at)
                      }}</span>
                      <span style="font-size: 14px !important">- Đã ký</span>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <modalCreateForm ref="modalTreatment" :type="'update'" @refreshERM="getEMRTreatmentByID" />
    <ModalSaveDocumentTemplate
      ref="ModalSaveDocumentTemplate"
      :doc-content="docContent"
      :doc-type="MENU_EMR_TEMPLATE[3].value"
    />
    <ModalSignPDF
      containerIDProps="TreatmentFormContainerPDF"
      elementIDProps="TreatmentFormSignerPDF"
      imageIDProps="TreatmentFormImageID"
      ref="TreatmentFormSignerPDF"
      :envelopeName="envelopeName"
      @onSuccess="handleSignDocumentSuccess"
    />
  </div>
</template>

<script>
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import html2pdf from 'html2pdf.js'
import _ from 'lodash'
import { mapState } from 'vuex'
import SignatureRequest from '../../../api/request/SignatureRequest'
import appUtils from '../../../utils/appUtils'
import {
  ENVELOPE_DOCUMENT_TYPE,
  ENVELOPE_NAME_TYPE,
  MENU_EMR_TEMPLATE
} from '../../../utils/constants'
import { mixinSignPdf } from '../../../utils/mixinSignPdf'
import ModalSignPDF from '../../Signature/ModalSignPDF.vue'
import ModalSaveDocumentTemplate from '../ModalSaveDocumentTemplate.vue'
import modalCreateForm from './ModalTreatment.vue'
import moment from 'moment'

export default {
  name: 'TreatmentDetail',
  components: { modalCreateForm, ModalSaveDocumentTemplate, ModalSignPDF },
  props: ['treatmentId', 'formData', 'isLoading'],
  mixins: [mixinHasFeatures, mixinSignPdf],
  data () {
    const defaultForm = {
      name: '',
      date: '',
      examination: '',
      symptom: '',
      other_disease: '',
      solution: '',
      diagnostic_code: '',
      diagnostic_name: '',
      diet_order: '',
      care_order: '',
      emr_treatment_medicines: [],
      emr_treatment_materials: [],
      emr_treatment_images: []
    }

    return {
      medicines1: [
        {
          code: '',
          name: '',
          type: 1,
          remark: ''
        }
      ],
      medicines2: [
        {
          code: '',
          name: '',
          type: 2,
          remark: ''
        }
      ],
      materials: [
        {
          code: '',
          name: '',
          remark: ''
        }
      ],
      images: [
        {
          code: '',
          name: '',
          remark: ''
        }
      ],
      dataTable: [],
      defaultForm,
      form: defaultForm,
      loading: this.isLoading || false,
      dateRange: [],
      appUtils,
      MENU_EMR_TEMPLATE,
      metaData: {}
    }
  },
  computed: {
    ...mapState({
      person: (state) => state.person,
      medicalRecordMain: (state) => state.medicalRecordMain,
      emrData: (state) => state.emrData
    }),
    envelopeName () {
      return this.handleGetEnvelopeName(ENVELOPE_NAME_TYPE.emr, this.emrData)
    },
    docContent () {
      return {
        disease_progression: {
          label: 'Diễn biến bệnh',
          value: this.form.disease_progression,
          editor: 1
        },
        solution: {
          label: 'Xử trí',
          value: this.form.solution,
          editor: 1
        },
        diet_order: {
          label: 'Chế độ ăn',
          value: this.form.diet_order,
          editor: 1
        },
        care_order: {
          label: 'Chế độ chăm sóc',
          value: this.form.care_order,
          editor: 1
        }
      }
    }
  },
  mounted () {
    let self = this

    self.getEMRTreatmentByID(self.formData?.id)

    if (self.formData) {
      const data = self.formData
      if (self.treatmentId) {
        self.form = {
          ...self.form,
          ...data
        }
        const sortArray = []
        if (data.appt_date) {
          sortArray.push(data, {
            appt_date_only: data.appt_date,
            user_name: data.user_name
          })
        } else {
          sortArray.push(data)
        }

        self.dataTable = sortArray
      } else {
        if (Number(self.$route.query?.treatment_date)) {
          const date = Number(self.$route.query?.treatment_date)
          const params = {
            from: window.moment(date).startOf('day').toDate(),
            to: window.moment(date).endOf('day').toDate()
          }

          self.dateRange = [
            window.moment(date).format('YYYY-MM-DD'),
            window.moment(date).format('YYYY-MM-DD')
          ]
          self.getEMRTreatments(params)
          return
        } else if (Number(self.$route.query?.id_treatment)) {
          const id = Number(self.$route.query?.id_treatment)
          self.getEMRTreatmentByID(id)
          return
        }

        self.dataTable = data
        self.dateRange = [data[0]?.date, data[0]?.date]
      }
    }
  },
  watch: {
    isLoading (status) {
      this.loading = status
    },
    // form(val) {
    //   this.dataTable = [val];
    // },
    '$route.query.type' (val) {
      this.type = val
    },
    formData (data) {
      if (data) {
        if (this.treatmentId) {
          this.form = {
            ...this.form,
            ...data
          }
          this.dataTable = [data]
        } else {
          this.dataTable = data
          this.dateRange = [data[0]?.date, data[0]?.date]
        }

        this.metaData = appUtils.isJSON(data[0]?.meta_data)
          ? JSON.parse(data[0]?.meta_data)
          : {}
      } else {
        this.form = this.defaultForm
        this.dataTable = []
        this.metaData = {}
      }
    },
    treatmentId (id) {
      const data = this.formData
      if (id) {
        this.form = {
          ...this.form,
          ...data
        }
        this.dataTable = [data]
      } else {
        this.dataTable = data
        this.dateRange = [data[0]?.date, data[0]?.date]
      }
    }
  },
  methods: {
    async onPrintNe (isOpen = true) {
      const self = this
      const bodyHTML = self.$refs.documentPrint.innerHTML
      const tempHTML = appUtils.templateHTMLPrint({ bodyHTML })
      const base64Data = appUtils.base64.decode(tempHTML)
      const url = await this.savePdfToS3(base64Data, isOpen)
      return url
    },
    async savePdfToS3 (base64, isOpen) {
      try {
        this.loading = true

        const payload = {
          content: base64,
          fileName: 'PhieuDieuTri',
          path: 'consultations',
          type: 'test',
          type_id: 'test',
          uuid: 'test'
        }

        const res = await this.$rf
          .getRequest('DoctorRequest')
          .printDocument(payload)

        if (res?.data && isOpen) {
          window.open(res.data?.documentLink, '_blank', 'noreferrer')
        }
        this.loading = false
        return res.data?.documentLink
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (row.appt_date_only) {
        if (columnIndex === 0) {
          return [1, 3]
        } else if (columnIndex === 1) {
          return [0, 0]
        } else if (columnIndex === 2) {
          return [0, 0]
        } else if (columnIndex === 3) {
          return [0, 0]
        }
      }
    },
    ModalUpdate (show) {
      show && this.$refs.modalTreatment.openDialog(true)
    },
    getGender () {
      return appUtils.getGender(this.person.gender)
    },
    formatDate (date) {
      if (!date) return ''
      return window.moment(date).format('HH:mm DD/MM/YYYY')
    },
    getYear () {
      return (
        this.person.birthday &&
        (window.moment(this.person.birthday).year()
          ? window.moment(this.person.birthday).year()
          : '')
      )
    },
    getTreatDeptMain () {
      let result = ''
      if (this.form.diagnostic_code || this.form.diagnostic_name) {
        result =
          (this.form.diagnostic_code || '') +
          ' - ' +
          (this.form.diagnostic_name ||
            '.................................................')
      } else {
        if (
          this.medicalRecordMain &&
          this.medicalRecordMain.treat_dept_main_code
        ) {
          result += this.medicalRecordMain.treat_dept_main_code
        }
        if (
          this.medicalRecordMain &&
          this.medicalRecordMain.treat_dept_main_name
        ) {
          result = result + '-' + this.medicalRecordMain.treat_dept_main_name
        }
      }
      return result
    },
    async getEMRTreatmentByID (Id) {
      let id = Id || this.treatmentId

      if (!id) {
        return
      }

      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getEMRTreatmentByID(id)
        .then((r) => {
          this.form = r.data
          const sortArray = []
          if (r.data.appt_date) {
            sortArray.push(r.data, {
              appt_date_only: r.data.appt_date,
              user_name: r.data.user_name
            })
          } else {
            sortArray.push(r.data)
          }

          this.dataTable = sortArray
          this.metaData = r.data?.meta_data
          this.mapData(r.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async postERMTreatment () {
      this.loading = true
      this.deleteValueNull(this.medicines1)
      this.deleteValueNull(this.medicines2)
      this.deleteValueNull(this.materials)
      this.deleteValueNull(this.images)

      const params = {
        ...this.form,
        medical_record_id: this.$route.params.id,
        emr_treatment_medicines: [...this.medicines1, ...this.medicines2],
        emr_treatment_materials: [...this.materials],
        emr_treatment_images: [...this.images]
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .postERMTreatment(params)
        .then((r) => {
          this.$toast.open({
            message: 'Tải lên thành công',
            type: 'success'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async updateERMTreatment (id) {
      this.loading = true
      this.deleteValueNull(this.medicines1)
      this.deleteValueNull(this.medicines2)
      this.deleteValueNull(this.materials)
      this.deleteValueNull(this.images)

      const params = {
        ...this.form,
        medical_record_id: this.$route.params.id,
        emr_treatment_medicines: [...this.medicines1, ...this.medicines2],
        emr_treatment_materials: [...this.materials],
        emr_treatment_images: [...this.images]
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .updateERMTreatment(id, params)
        .then((r) => {
          this.$toast.open({
            message: 'Chỉnh sửa thành công',
            type: 'success'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    mapData (data) {
      if (data.materials) this.materials = data.materials
      if (data.indication_labs) this.indications = data.indication_labs
      if (data.indication_pacs) this.images = data.indication_pacs
      if (data.medicines) {
        this.medicines1 = data.medicines.filter((item) => {
          return item.type === 1
        })
        this.medicines2 = data.medicines.filter((item) => {
          return item.type === 2
        })
      }
    },
    submit () {
      let id = this.$route.query.id_treatment
      if (!id) {
        this.postERMTreatment()
      } else this.updateERMTreatment(id)
      this.goToView('view')
    },
    deleteValueNull (array) {
      _.remove(array, function (item) {
        return !item.name
      })
    },
    addItem (item, type) {
      const temp = {
        code: '',
        name: '',
        remark: ''
      }
      if (type) temp['type'] = type
      item.push(temp)
    },
    deleteItem (item, index) {
      if (item[index].id) {
        this.$set(item[index], 'deleted', true)
      } else item.splice(index, 1)
    },
    goToView (type) {
      this.$router
        .replace({
          query: {
            tab: this.$route.query.tab,
            id_treatment: this.$route.query.id_treatment,
            type
          }
        })
        .catch((_) => {})
    },
    backList () {
      this.$router
        .replace({ query: { tab: this.$route.query.tab } })
        .catch((_) => {})
    },
    exportPdf () {
      this.loading = true
      setTimeout(async () => {
        let options = {
          // pagebreak: {
          //   mode: ['avoid-all', 'css', 'legacy']
          // },
          margin: [7, 11, 7, 7],
          filename: `Phieu_Dieu_Tri_${this.form.name}_Ngay_${
            this.form.date || this.dataTable[0]?.date || ''
          }.pdf`,
          html2canvas: {
            dpi: 192,
            scale: 2,
            image: { type: 'png', quality: 1 },
            letterRendering: true,
            allowTaint: true,
            logging: true,
            useCORS: true
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }
        await html2pdf().from(this.$refs.viewDetail).set(options).save()
        this.loading = false
      }, 10)
    },
    openFile (url) {
      window.open(url)
    },
    async getEMRTreatments (params) {
      let id = this.$route.params.id
      if (!id) {
        return
      }
      const paramsData = {
        ...params,
        limit: 50,
        page: this.$route.query.page || 1,
        sort: 'date',
        sort_by: 'desc'
      }
      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getEMRTreatments(id, paramsData)
        .then((r) => {
          const _data = r.data?.data
          this.form = { ..._data }
          const indexPdf = _data.findIndex((x) => x.pdf_url)
          if (indexPdf !== -1) {
            _data.splice(indexPdf, 1)
          }
          this.processDataWithApptDate(_data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    processDataWithApptDate (data) {
      const sortArray = []
      data.forEach((x) => {
        if (x.appt_date) {
          sortArray.push(x, {
            appt_date_only: x.appt_date,
            user_name: x.user_name
          })
        } else {
          sortArray.push(x)
          // sortArray.push(x, {
          //   appt_date_only: null,
          //   user_name: null
          // })
        }
      })
      this.dataTable = sortArray
    },
    filterApptDate () {
      const data = this.dataTable?.filter((item) => item?.appt_date)
      return data
    },
    onSubmitDateRange () {
      const params = {}
      if (this.dateRange && this.dateRange.length > 1) {
        params.from = window.moment(this.dateRange[0]).startOf('day').toDate()
        params.to = window.moment(this.dateRange[1]).endOf('day').toDate()
        this.getEMRTreatments(params)
      }
    },
    showModalSaveDocTemplate (show) {
      this.$refs.ModalSaveDocumentTemplate.showModalSaveDocTemplate(show)
      // window.$('#modalSaveDocTemplate-4').modal(show ? 'show' : 'hide')
    },
    async handleSignature () {
      const id = this.treatmentId || Number(this.$route.query?.id_treatment)
      if (!id) return

      try {
        const data = {
          sign_at: Date.now(),
          treatment_id: id
        }
        const res = await this.$rf
          .getRequest('DoctorRequest')
          .signTreatmentByID(data)
        if (!res?.data) return

        await this.getEMRTreatmentByID(id)

        this.$message({
          type: 'success',
          message: this.$t('Signature OK')
        })
      } catch (error) {
        console.log(error)
      }
    },
    getDoctorData (record) {
      let metaDataRaw = record?.meta_data
      if (appUtils.isJSON(metaDataRaw)) {
        metaDataRaw = JSON.parse(metaDataRaw)
      }
      const doctor = record?.user_name || metaDataRaw?.BacSiChiDinh
      return doctor
    },
    getDoctorSignData (record) {
      const doctor = record?.sign_by_user?.name || ''
      return doctor
    },
    getIndicationImages (record) {
      const indicationImages = record?.indication_pacs.indications || []
      return indicationImages
    },
    getDateTime (record) {
      if (!record?.date) return ''
      return moment(record.date).utc().format('HH:mm DD/MM/YYYY')
    },
    async openModalSignPDF () {
      if (this.form.user_id !== this.$user?.id) {
        this.$toast.open({
          message: 'Bạn không có quyền ký tài liệu này',
          type: 'error'
        })
        return
      }

      const documentLink = await this.onPrintNe(false)

      if (!documentLink) {
        this.$toast.open({
          message: 'Không tìm thấy tài liệu cần ký',
          type: 'error'
        })
        return
      }

      const procedureResponse = await this.getSignProcedure()
      const procedureSelected = procedureResponse?.data?.[0] || {}

      const signatories = procedureSelected?.sign_nodes?.reduce((arr, node) => {
        const signs = node?.node_signatories?.map((item) => {
          let user
          if (item?.user_role === 'treatment_doctor') {
            user = {
              id: this.form.user_id,
              name: this.form.user?.name,
              email: this.form.user?.email
            }
          }

          return {
            ...item,
            user,
            user_id: user?.id
          }
        })

        return arr.concat(signs)
      }, [])

      const signerInfo = signatories?.find(
        (item) => item?.user_id === this.$user?.id
      )
      if (!signerInfo) {
        this.$toast.open({
          type: 'error',
          message: 'Bạn không có quyền ký tài liệu này'
        })

        return
      }

      this.$refs.TreatmentFormSignerPDF.handleOpen(
        documentLink,
        ENVELOPE_DOCUMENT_TYPE.TREATMENT_FORM,
        Number(this.$route.query.id_treatment),
        signerInfo?.user_id,
        signatories,
        null,
        procedureSelected?.id
      )
    },
    async getSignProcedure () {
      try {
        const params = {
          page_num: 1,
          page_size: 1000,
          order: 'desc',
          sort_by: 'id',
          document_type: ENVELOPE_DOCUMENT_TYPE.TREATMENT_FORM,
          ws_id: this.$globalClinic?.id
        }

        const request = new SignatureRequest()

        const response = await request.getSignProcedures(params)
        return response.data
      } catch (error) {
        console.log(error)
      }
    },
    async handleSignDocumentSuccess (dataBase64, responseEnvelope) {
      try {
        this.loading = true
        const file = appUtils.convertBase64tToFile(
          dataBase64,
          parseInt(Date.now() / 1000)
        )
        const url = await this.uploadFiles(
          file,
          Number(this.$route.query.id_treatment)
        )
        await this.handleUpdateEnvelopeDocumentURL(responseEnvelope, url)
        window.open(url, '_blank')
        await this.handleSignature()
        this.$emit('onSignSuccess')
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async uploadFiles (file, id) {
      const params = {
        file,
        FolderTarget: `consultation`,
        IdTarget: id
      }
      const formData = new FormData()

      for (const key in params) {
        formData.append(key, params[key])
      }

      const res = await this.$rf
        .getRequest('DoctorRequest')
        .uploadFileTenant(formData)
      return res.data.fileUrl
    },
    async handleUpdateEnvelopeDocumentURL (responseEnvelope, url) {
      if (!responseEnvelope?.id) return

      try {
        const request = new SignatureRequest()

        const response = await request.updateEnvelope(responseEnvelope.id, {
          document_url: url
        })

        if (response.status === 200) {
          this.$toast.open({
            message: 'Ký thành công',
            type: 'success'
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-table--border,
  .el-table--group {
    border: 1px solid #000;
  }

  .el-table--border th.el-table__cell,
  .el-table__fixed-right-patch {
    border-bottom: 1px solid #000 !important;
  }

  .el-table__header {
    width: 100%;
  }

  .el-table--border .el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-right: 1px solid #000 !important;
    border-bottom: 1px solid #000 !important;
  }

  .el-table--border th.el-table__cell > div.cell {
    line-height: 1.25 !important;
  }

  div.cell {
    padding: 0 4px !important;

    a {
      color: #20409b !important;
    }
  }

  thead th.padding-header {
    padding: 0 8px !important;
  }

  thead th.header-text-left {
    text-align: left !important;
    padding: 0 8px !important;
  }

  .break-words {
    overflow-wrap: break-word !important;
    word-break: break-word !important;
    word-wrap: break-word !important;
    white-space: break-spaces !important;
  }

  .copy-icon {
    width: 24px !important;
    height: 24px !important;
  }
}
</style>
